import { CheckCircle2 } from 'lucide-react';

const upgrades = [
  'Inside Oven', 'Garage Sweep Out',
  'Inside Refrigerator', 'Laundry Room Deep Cleaning',
  'Interior Windows', 'Additional Services Available',
  'Exterior Windows', 'Blinds Detail Cleaning'
];

export const UpgradeOptions = () => (
  <div className="text-center lg:text-left">
    <span className="inline-block bg-[#2E7D32] text-white font-bold text-sm px-5 py-2 rounded-lg mb-5 uppercase tracking-wide">
      Upgrade Options
    </span>
    <p className="text-[#555] mb-5 text-sm sm:text-base">Available upon request:</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 max-w-md mx-auto lg:mx-0">
      {upgrades.map((item, i) => (
        <div key={i} className="flex items-center gap-2.5 justify-center lg:justify-start">
          <CheckCircle2 size={16} className="text-[#4CAF50] flex-shrink-0" />
          <span className="text-[#333] text-sm">{item}</span>
        </div>
      ))}
    </div>
  </div>
);
